export default "__VITE_ASSET__CI6COMo6__"